import { lazy } from 'react';
import { createBrowserRouter } from 'react-router';
import { RouteError } from 'components/common/Routes/RouteError';
import { Search } from 'components/pages/ConsultantPage/components/NavigationPanel/components/Search/Search';
import { ProfileWindow } from 'components/pages/ConsultantPage/components/NavigationPanel/components/Profile/components/ProfileWindow/ProfileWindow';
import { Account } from 'components/pages/ConsultantPage/components/NavigationPanel/components/Profile/components/Account/Account';
import { ChangePassword } from 'components/pages/ConsultantPage/components/NavigationPanel/components/Profile/components/Account/ChangePassword/ChangePassword';
import { Personalization } from 'components/pages/ConsultantPage/components/NavigationPanel/components/Profile/components/Personalization/Personalization';
import { Instruction } from 'components/pages/ConsultantPage/components/NavigationPanel/components/Profile/components/Personalization/Instruction/Instruction';
import { Settings } from 'components/pages/ConsultantPage/components/NavigationPanel/components/Profile/components/Settings/Settings';
import { ReportProblem } from 'components/pages/ConsultantPage/components/NavigationPanel/components/Profile/components/ReportProblem/ReportProblem';
import { Project } from 'components/pages/ConsultantPage/components/NavigationPanel/components/Projects/components/Project/Project';
import { ProjectsWindow } from 'components/pages/ConsultantPage/components/NavigationPanel/components/Projects/components/ProjectsWindow/ProjectsWindow';
import { ConsultantModalOutlet } from 'components/pages/ConsultantPage/components/Content/components/ConsultantModalOutlet/ConsultantModalOutlet';
import { Prices } from 'components/pages/ConsultantPage/components/NavigationPanel/components/Profile/components/Prices/Prices';
import { RequestsHistory } from 'components/pages/ConsultantPage/components/NavigationPanel/components/Profile/components/Prices/components/RequestsHistory/RequestsHistory';
import { PaymentHistory } from 'components/pages/ConsultantPage/components/NavigationPanel/components/Profile/components/Prices/components/PaymentHistory/PaymentHistory';
import { Support } from 'components/pages/ConsultantPage/components/NavigationPanel/components/Profile/components/Support/Support';
import { ModalNavigationOutlet } from 'components/pages/ConsultantPage/components/ModalNavigationOutlet/ModalNavigationOutlet';
import { QuestionDetails } from 'components/pages/ConsultantPage/components/NavigationPanel/components/Profile/components/Support/QuestionDetails/QuestionDetails';
import AppLayout from 'components/layouts/AppLayout';
import PaymentPage from 'components/pages/PaymentPage/PaymentPage';

const AuthPage = lazy(
  (/* webpackChunkName: "AuthPage" */) =>
    import('components/pages/AuthPage/AuthPage'),
);
const ConsultantLayout = lazy(
  (/* webpackChunkName: "ConsultantLayout" */) =>
    import('components/layouts/ConsultantLayout'),
);
const ConsultantPage = lazy(
  (/* webpackChunkName: "ConsultantPage" */) =>
    import('components/pages/ConsultantPage/ConsultantPage'),
);
const Welcome = lazy(
  (/* webpackChunkName: "Welcome" */) =>
    import(
      'components/pages/ConsultantPage/components/Content/components/Welcome/Welcome'
    ),
);
const ActiveChat = lazy(
  (/* webpackChunkName: "ActiveChat" */) =>
    import(
      'components/pages/ConsultantPage/components/Content/components/ActiveChat/ActiveChat'
    ),
);
const NotFoundPage = lazy(
  (/* webpackChunkName: "NotFoundPage" */) =>
    import('components/pages/NotFoundPage/NotFoundPage'),
);

const modalPages = [
  {
    path: 'profile',
    element: <ModalNavigationOutlet />,
    children: [
      {
        index: true,
        element: <ProfileWindow />,
      },
      {
        path: 'account',
        element: <ModalNavigationOutlet />,
        children: [
          {
            index: true,
            element: <Account />,
          },
          {
            path: 'change-password',
            element: <ChangePassword />,
          },
        ],
      },
      {
        path: 'personalization',
        element: <ModalNavigationOutlet />,
        children: [
          {
            index: true,
            element: <Personalization />,
          },
          {
            path: 'instruction',
            element: <Instruction />,
          },
        ],
      },
      {
        path: 'prices',
        element: <ModalNavigationOutlet />,
        children: [
          {
            index: true,
            element: <Prices />,
          },

          {
            path: 'payment-history',
            element: <PaymentHistory />,
          },
          {
            path: 'requests-history',
            element: <RequestsHistory />,
          },
        ],
      },
      {
        path: 'settings',
        element: <Settings />,
      },
      {
        path: 'report-problem',
        element: <ReportProblem />,
      },
      {
        path: 'support',
        element: <ModalNavigationOutlet />,
        children: [
          {
            index: true,
            element: <Support />,
          },
          {
            path: ':questionId',
            element: <QuestionDetails />,
          },
        ],
      },
    ],
  },
  {
    path: 'search',
    element: <Search />,
  },
  {
    path: 'projects',
    element: <ProjectsWindow />,
  },
  {
    path: 'project/:projectId',
    element: <Project />,
  },
];

export const Router = createBrowserRouter([
  {
    element: <AppLayout />,
    children: [
      {
        path: '/',
        element: (
          <ConsultantLayout>
            <ConsultantPage />
          </ConsultantLayout>
        ),
        children: [
          {
            path: '',
            element: (
              <>
                <Welcome />
                <ConsultantModalOutlet />
              </>
            ),
            children: modalPages,
          },
          {
            path: 'chat/:chatId',
            // loader: chatLoader,
            element: (
              <>
                <ActiveChat />
                <ConsultantModalOutlet />
              </>
            ),
            errorElement: <RouteError />,
            children: modalPages,
          },
        ],
      },
      {
        path: '/auth',
        element: <AuthPage />,
      },
      {
        path: 'payment',
        element: <PaymentPage />,
      },
      {
        path: '*',
        element: <NotFoundPage />,
      },
    ],
  },
]);
